package co.maytes.standupbot.dashboard.features.analytics

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.cssRgb
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

data class LegendItem(val label: String, val color: String)

@Composable
fun ChartLegend(items: List<LegendItem>) {
    if (items.isEmpty()) return
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .padding(leftRight = Spacing.sm, topBottom = Spacing.xs)
            .borderRadius(Radius.full)
            .gap(Spacing.md)
            .styleModifier {
                property("background", Palette.surfaceSubtle.cssRgb())
                property("border", "1px solid ${Palette.borderSubtle.cssRgb()}")
                property("flex-wrap", "wrap")
                property("justify-content", "flex-end")
            },
    ) {
        items.forEach { item ->
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.gap(Spacing.xs),
            ) {
                Box(
                    modifier = Modifier
                        .width(9.px)
                        .height(9.px)
                        .borderRadius(3.px)
                        .styleModifier {
                            property("background", item.color)
                            property("box-shadow", "0 0 0 3px ${legendSwatchHalo(item.color)}")
                        },
                )
                SpanText(
                    text = item.label,
                    modifier = Modifier
                        .fontSize(Typography.caption.size)
                        .fontWeight(500)
                        .color(Palette.textSecondary)
                        .styleModifier { property("white-space", "nowrap") },
                )
            }
        }
    }
}

private fun legendSwatchHalo(color: String): String {
    val clean = color.trim()
    if (!clean.startsWith("rgb(")) return "transparent"
    val inner = clean.removePrefix("rgb(").removeSuffix(")").trim()
    return "rgba($inner, 0.14)"
}
